module.exports = __webpack_public_path__ + "img/close.662573d2.png";